<div class='SelectUsersWizardStep'>
  <div *ngIf='singleSelection' class='alert alert-warning'>
    <p class='mb-0'>Franchisee reports are generated for one franchisee at a time. Please select a single franchisee.</p>
  </div>
  <app-table (rowSelected)='onRowSelection($event)' [columns]='tableColumns' [dataSourceParams]='tableDatasourceParams'
             [dataSource]='tableDataSource'
             [enableSingleSelection]='singleSelection'
             [filterGroups]='tableFilterGroups' [preselectedIdentifier]="'account_id'"
             [preselected]='preselected' [selectable]='true'></app-table>
</div>